
import React, { useState, useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Grid, Typography } from "@mui/material";

import"../../style/sostenibilidad/galeria.css"

/* imagenes */
import imagen from "../../img/seguridad/galeria/1.jpg"
import imagen2 from "../../img/seguridad/galeria/2.jpg"
import imagen3 from "../../img/seguridad/galeria/3.jpg"
import imagen4 from "../../img/seguridad/galeria/4.jpg"
import imagen5 from "../../img/seguridad/galeria/5.jpg"
import imagen6 from "../../img/seguridad/galeria/6.jpg"
import imagen7 from "../../img/seguridad/galeria/7.jpg"
import imagen8 from "../../img/seguridad/galeria/8.jpg"
import imagen9 from "../../img/seguridad/galeria/9.jpg"
import imagen10 from "../../img/seguridad/galeria/10.jpg"
import imagen11 from "../../img/seguridad/galeria/11.jpg"
import imagen12 from "../../img/seguridad/galeria/12.jpg"
import icono from "../../img/sostenibilidad/galeria/zoom.png"

const Datagaleria =[
    {
        id:1,
        imagen:imagen,
        titulo:"Campaña Día del Medioambiente"
    },
    {
        id:2,
        imagen:imagen2,
        titulo:"Bingo del Reciclaje"
    },
    {
        id:3,
        imagen:imagen3,
        titulo:"Disposición de residuos en Punto Limpio "
    },
    {
        id:4,
        imagen:imagen4,
        titulo:"Semana de la Seguridad"
    },
    {
        id:5,
        imagen:imagen5,
        titulo:"Limpieza de Playas"
    },
    {
        id:6,
        imagen:imagen6,
        titulo:"Curso prevención de riesgos"
    },
    {
        id:7,
        imagen:imagen7,
        titulo:"Capacitaciones en terreno"
    },
    {
        id:8,
        imagen:imagen8,
        titulo:"Taller Protección  Respiratoria en línea"
    },
    {
        id:9,
        imagen:imagen9,
        titulo:"Participacion en feria de seguridad"
    },
    {
        id:10,
        imagen:imagen10,
        titulo:"Día mundial de la seguridad en el trabajo"
    },
    {
        id:11,
        imagen:imagen11,
        titulo:"Campaña Orden y Limpieza"
    },
    {
        id:12,
        imagen:imagen12,
        titulo:"Día Mundial de la Tierra"
    },

]

export default function Seguridadgaleria() {
  useEffect(() => {
    // Inicializa AOS con opciones de configuración si es necesario
    AOS.init({
      duration: 1000, // Duración de las animaciones en milisegundos
      once: true, // Solo realiza las animaciones una vez
    });
  }, []);
    const [popupVisible, setPopupVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openPopup = (image) => {
    setSelectedImage(image);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setSelectedImage(null);
    setPopupVisible(false);
  };
  return (
    <section className="segurgle">
      <section className="titulo-galeria" data-aos="fade-down">
        <h1>Galería de fotos</h1>
        <span>Actividades más destacadas</span>
      </section>
      <section className="galeria">
      <Grid container >
          {Datagaleria.map((item) => (
            <Grid key={item.id} item xs={12} sm={6} md={4} className="gal-foto" data-aos="zoom-in">
               <div className="imagen-galeria" onClick={() => openPopup(item.imagen)}>
                <img
                  src={item.imagen}
                  width={'100%'}
                  height={'100%'}
                  alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos'
                  
                />
                <div className="titulo-overlay">
                  <Typography  component="div" className="titulo">
                    {item.titulo}
                  </Typography>
                  <img
                    src={icono}
                    alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos'
                    className="icono-zoom"
                  />
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </section>
     
      {popupVisible && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-contentgaleria">
            {selectedImage && (
                <div  className="imagenesgaleria">
              <img
                src={selectedImage}
                width={'100%'}
                height={'100%'}
                alt="axinntus"
                className="imagen-galeria"
               
              /></div>
            )}
           
          </div>
        </div>
      )}
    </section>
  );
}
